import Vue from 'vue'

import Vuex from 'vuex'

Vue.use(Vuex)



export default new Vuex.Store({

    state: {
        is_app:false,//是否app打开

        phone:'',//用户信息
        password:'',//密码
        invitation:'',//邀请码
        basic:{},//基本信息

        column_id:'',//栏目id
        parsonal_path:'',//设置路由

        pageNum:0,//推文距离

        query_url:'',//跳转链接
    },

    mutations: {
        setApp(state,eve){
            state.is_app = eve;
        },
        setPhone(state,eve){
            state.phone = eve;
        },
        setRepeat(state,eve){
            state.is_repeat = eve;
        },
        setPassword(state,eve){
            state.password = eve;
        },
        setInvitation(state,eve){
            state.invitation = eve;
        },
        setBasic(state,eve){
            state.basic = eve;
        },
        setColumn(state,eve){
            state.column_id = eve;
        },
        setParsonalPath(state,eve){
            state.parsonal_path = eve;
        },
        setLoginUser(state,eve){
            state.loginUser = eve;
        },
        pageFun(state,eve){
            state.pageNum = eve;
        },
        queryUrl(state,eve){
            state.query_url = eve;
        }
    }
})


// WEBPACK FOOTER //
// ./src/store/store.js